import React, { useEffect, useRef, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import storeSettingIconSrc from "../../../src/assets/svgs/store-setting.svg";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useGroupDeviceState } from "./Provider";
import { Rule } from "../../helpers/DeviceNamingDatatable";

import StoreApi from "@/apis/storeAPI";
import { message } from "antd";
import _ from "lodash";
import localforage from "localforage";
import { APP_ENV } from "@/APP_ENV";
import { getNubisDomain } from "@/helpers/utils";

const BootstrapButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 14,
    padding: "10px 37px",
    border: "none",
    lineHeight: "20px",
    backgroundColor: "#d9f0f4",
    borderColor: "#00AFC6",
    color: "#00B8CF",
    fontFamily: [
      "PingFangSC",
      "PingFang SC",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:hover": {
      backgroundColor: "#00AFC6",
      borderColor: "##00AFC6",
      color: "#ffffff",
      boxShadow: "none"
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "#00AFC6",
      color: "#ffffff",
      borderColor: "##00AFC6"
    },
    "&:focus": {
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    }
  }
})(Button);

const useModalStyles = makeStyles(theme => ({
  StoreSettingModal: {
    "& .info-box": {
      height: 50,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      "margin-bottom": 24,
      fontSize: "14px",
      "& .info-line": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        "& .icon": {
          marginRight: "10px"
          // display: "flex",
          // alignItems: "center",
        },
        "& .label": {
          fontWeight: 400,
          width: 70,
          textAlign: "right"
        },
        "& .name": {
          fontWeight: 500
        }
      }
    },

    "& .token-box": {
      height: 152,
      padding: "20px 24px",
      backgroundColor: "#F8F9FC",
      "border-radius": "10px",
      display: "flex",
      flexDirection: "column",
      "justify-content": "space-between",
      "& .token-look": {
        display: "flex",
        alignItems: "center",
        "& .label,.token-value": {
          height: 40,
          display: "flex",
          alignItems: "center",
          fontSize: 16,
          color: "#333333"
        },
        "& .token-value": {
          fontSize: 28,
          color: "#00AFC6",
          paddingBottom: 6
        }
      },
      "& button": {
        marginRight: 16
      }
    },
    "& .setting-title": {
      fontSize: 14,
      padding: "20px 0",
      color: "#333333",
      fontWeight: 500
    },

    "& .table-list": {
      "& .TableContainer": {
        padding: "0 0",
        color: "#333333",
        maxHeight: 163,
        borderRadius: "10px",
        "&.MuiPaper-elevation1": {
          "box-shadow": "none"
        },
        "& .MuiTableRow-head": {
          backgroundColor: "#DDDDDD",
          "& .MuiTableCell-head": {
            color: "#333333"
          }
        },
        "& .MuiTableCell-root,.MuiTableCell-body": {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }
    }
  },
  StoreSettingModalBox: {}
}));
function TranserModal({ open, onConfirm, onClose, rowData }) {
  const { t } = useTranslation();
  const { currentCompanyId, storeId, operateType } = useGroupDeviceState();
  const [state, setState] = useState({
    companyName: "",
    storeName: "",
    list: [
      {
        id: 1,
        type_name: "Android",
        rule_type_name: "直营Android",
        setting_name: "配置文件A",
        rule_name: "自定义文字-自然数递增"
      },
      {
        id: 2,
        type_name: "window",
        rule_type_name: "直营windows",
        setting_name: "配置文件B",
        rule_name: "自定义文字-自然数递增"
      },
      {
        id: 3,
        type_name: "Android",
        rule_type_name: "直营Android",
        setting_name: "配置文件A",
        rule_name: "自定义文字-自然数递增"
      },
      {
        id: 3,
        type_name: "Android",
        rule_type_name: "直营Android",
        setting_name: "配置文件A",
        rule_name: "自定义文字-自然数递增"
      },
      {
        id: 3,
        type_name: "Android",
        rule_type_name: "直营Android",
        setting_name: "配置文件A",
        rule_name: "自定义文字-自然数递增"
      },
      {
        id: 3,
        type_name: "Android",
        rule_type_name: "直营Android",
        setting_name: "配置文件A",
        rule_name: "自定义文字-自然数递增"
      },
      {
        id: 3,
        type_name: "Android",
        rule_type_name: "直营Android",
        setting_name: "配置文件A",
        rule_name: "自定义文字-自然数递增"
      }
    ]
  });

  const [token, setToken] = useState({
    groupToken: "",
    companyToken: ""
  });

  // console.log("-----rowData-----",rowData)

  const classes = useModalStyles();
  // 确定
  const handleConfirm = () => {
    // return onConfirm(state.list)
  };
  // 节流函数
  const throttledMethodRef = useRef();

  useEffect(() => {
    if (rowData && Object.keys(rowData).length > 0) {
      // console.log("----setting rowData---",rowData)
      getStoreSettingInfo();
    }

    throttledMethodRef.current = _.throttle(
      handlleFunc => {
        // 你的逻辑代码
        handlleFunc();
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    );
  }, [rowData, open]);

  const getCompanyId = async () => {
    const user_company_id = await localforage.getItem("userCompanyID");
    return currentCompanyId ? currentCompanyId : user_company_id;
  };

  // 获取门店配置信息
  const getStoreSettingInfo = () => {
    StoreApi.GetStoreSettingInfo({
      companyId: rowData.company_id,
      groupId: rowData.id
    }).then(res => {
      setState({
        ...state,
        list: res.configs
      });
    });

    StoreApi.GetStoreSettingToken({
      companyId: rowData.company_id,
      groupId: rowData.id
    }).then(res => {
      setToken(res);
      if (!res.groupToken || res.groupToken.length <= 0) {
        handleRefreshToken();
      }
    });
  };

  // 更新token
  const handleRefreshToken = async () => {
    const res = await StoreApi.RefreshToken({
      companyId: rowData.company_id,
      groupId: rowData.id
    });
    setToken({
      ...token,
      groupToken: res.token
    });
    // message.success(t({defaultMessage: "刷新成功"}))
  };
  // 复制token
  const handleCopyToken = () => {
    var copyText = document.getElementById("copyText").innerHTML;
    // 创建一个临时的输入框来存储要复制的文本
    const input = document.createElement("input");
    input.value = copyText;
    // 将临时输入框添加到页面，并选中文本
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    // 移除临时输入框
    document.body.removeChild(input);
    message.success(t({ defaultMessage: "复制成功" }));
  };
  // 导出json
  const handleExportJson = () => {
    StoreApi.handleExportToken({
      ...token
    });
  };
  const nubisUrl = new URL(getNubisDomain());

  const TableBox = () => {
    return (
      <TableContainer component={Paper} className={`TableContainer`}>
        <Table
          className={classes.table}
          size="medium"
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <TableCell align="center">
                {t({ defaultMessage: "序号" })}
              </TableCell>
              <TableCell align="center">
                {t({ defaultMessage: "设备系统类型" })}
              </TableCell>
              <TableCell align="center">
                {t({ defaultMessage: "关联配置文件" })}
              </TableCell>
              <TableCell align="center">
                {t({ defaultMessage: "命名规则名称" })}
              </TableCell>
              <TableCell align="center">
                {t({ defaultMessage: "命名规则" })}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state.list.map((row, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row" align="center" width={65}>
                  {index + 1}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  align="center"
                  width={120}
                >
                  {row.osType}
                </TableCell>
                <TableCell align="center" width={120}>
                  <div style={{ color: "#00B2C9" }}>
                    {
                      <a
                        href={`${nubisUrl.origin}/profile-config/template-${
                          row.osType === "Android" ? "android" : "windows"
                        }/${row.configId}`}
                      >
                        {row.configId}
                      </a>
                    }
                  </div>
                </TableCell>
                <TableCell align="center" width={120}>
                  {row.namingRuleName}
                </TableCell>
                <TableCell align="left">
                  <Rule
                    rules={row.namingRuleRules}
                    delimiter={row.namingRuleDelimiter}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Modal
      title={t({ defaultMessage: "门店配置信息" })}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      className={classes.StoreSettingModal}
      footer={() => {
        return `<></>`;
      }}
      width={706}
      height={461}
    >
      <div className={classes.StoreSettingModalBox}>
        <div className={`info-box`}>
          <div className={`info-line`}>
            <div className={`icon`}>
              <img src={storeSettingIconSrc} />
            </div>
            <div className={`label`}>{t({ defaultMessage: "公司" })}：</div>
            <div className={`name`}>{rowData && rowData.company_name}</div>
          </div>
          <div className={`info-line`}>
            <div className={`icon`}>
              <img src={storeSettingIconSrc} />
            </div>
            <div className={`label`}>{t({ defaultMessage: "门店" })}：</div>
            <div className={`name`}>{rowData && rowData.name}</div>
          </div>
        </div>
        <div className={`token-box`}>
          <div className={`token-look`}>
            <div className={`label`}>
              {t({ defaultMessage: "查看Token" })}：
            </div>
            <div className={`token-value`} id={"copyText"}>
              {token.groupToken}
            </div>
          </div>
          <div>
            <BootstrapButton
              onClick={() => {
                throttledMethodRef.current(handleRefreshToken);
              }}
              color="primary"
              className={`my-button`}
            >
              {t({ defaultMessage: "更新Token" })}
            </BootstrapButton>
            <BootstrapButton
              onClick={() => {
                handleCopyToken();
              }}
              color="primary"
              className={`my-button`}
            >
              {t({ defaultMessage: "复制" })}
            </BootstrapButton>
            <BootstrapButton
              onClick={() => {
                handleExportJson();
              }}
              color="primary"
              className={`my-button`}
            >
              {t({ defaultMessage: "导出JSON" })}
            </BootstrapButton>
          </div>
        </div>
        <div className={`setting-title`}>
          {t({ defaultMessage: "门店关联的配置文件与命名规则" })}
        </div>
        <div className={`table-list`}>
          <TableBox />
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(TranserModal);
